import React from "react";
import {
  PrimaryButton,
  Dialog,
  DialogType,
  DialogFooter,
  DefaultButton,
} from "office-ui-fabric-react/lib";

interface showConfirmDialogFunc {
  (
    title: string,
    content: string,
    successHandler: Function,
    yesText?: string,
    hideCancelButton?: boolean
  ): void;
}

export const ConfirmDialogContext = React.createContext<{
  showConfirmDialog: showConfirmDialogFunc;
}>({ showConfirmDialog: () => {} });

export const ConfirmDialogProvider: React.FC<any> = (props) => {
  const [state, setState] = React.useState({
    isOpen: false,
    successHandler: undefined,
    title: "",
    content: "",
    yesText: "",
    hideCancelButton: false,
  } as {
    isOpen: boolean;
    successHandler?: Function;
    title: string;
    content: string;
    yesText?: string;
    hideCancelButton?: boolean;
  });
  const confirmDialogContext = React.useMemo(
    () => ({
      showConfirmDialog: (
        title: string,
        content: string,
        successHandler: Function,
        yesText?: string,
        hideCancelButton?: boolean
      ) => {
        setState({
          isOpen: true,
          successHandler,
          title,
          content,
          yesText: yesText || "",
          hideCancelButton: hideCancelButton || false,
        });
      },
    }),
    []
  );
  const closeDialog = () => {
    setState({
      ...state,
      isOpen: false,
    });
    // successHandler:undefined , title:"",content:""
  };
  return (
    <ConfirmDialogContext.Provider value={confirmDialogContext}>
      <>
        <Dialog
          hidden={!state.isOpen}
          onDismiss={() => {
            closeDialog();
          }}
          modalProps={{
            isBlocking: true,
            styles: { main: { maxWidth: 450 } },
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: state.title,
            subText: state.content,
          }}
        >
          <DialogFooter>
            {state.hideCancelButton !== true && (
              <DefaultButton
                onClick={() => {
                  closeDialog();
                }}
                color="secondary"
                className="borderless-btn"
              >
                Cancel
              </DefaultButton>
            )}
            <PrimaryButton
              onClick={() => {
                if (state.successHandler) {
                  state.successHandler();
                }
                closeDialog();
              }}
              autoFocus
            >
              {state.yesText || "Yes"}
            </PrimaryButton>
          </DialogFooter>
        </Dialog>
        {props.children}
      </>
    </ConfirmDialogContext.Provider>
  );
};

// HOC
export const withConfirmDialogContext = (ChildComponent: any) => (
  props: any
) => {
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  return (
    <ChildComponent {...props} confirmDialog={{ show: showConfirmDialog }} />
  );
};
